export default __webpack_public_path__ + "static/media/session-lead.7b7ddd68.md";